enum QuestionFormats {
  Score = 'score:basketball',
};

export default QuestionFormats;
